import { render, staticRenderFns } from "./channelmanagement.vue?vue&type=template&id=0bfa3262"
import script from "./channelmanagement.vue?vue&type=script&lang=js"
export * from "./channelmanagement.vue?vue&type=script&lang=js"
import style0 from "./channelmanagement.vue?vue&type=style&index=0&id=0bfa3262&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports